import {
  Box,
  Flex,
  Heading,
  Link,
  Stack,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react"
import NextLink from "next/link"

type ProductDetailsProps = {
  attributes: {
    name: string
    value: string[] | number[] | string | number | boolean | null
    key?: string
  }[]
}
const ProductDetails = ({ attributes }: ProductDetailsProps) => {
  const bgColor = useColorModeValue("gray.100", "gray.700")

  return (
    <Box w={"full"}>
      <Heading size={"md"}>{"Product Details"}</Heading>
      <VStack
        w={"full"}
        spacing={2}
        fontSize={"sm"}
        mt={6}
      >
        {attributes.map(
          (attr, index) =>
            attr.value && (
              <Flex
                key={index}
                w={"full"}
                alignItems={"center"}
              >
                <Box
                  minW={"45%"}
                  backgroundColor={bgColor}
                  p={2}
                  fontWeight={"bold"}
                  alignSelf={"stretch"}
                >
                  {attr.name}
                  {":"}
                </Box>
                <Stack
                  ms={4}
                  direction={"column"}
                  alignItems={"flex-start"}
                  spacing={1}
                  flexWrap={"wrap"}
                >
                  {attr.value instanceof Array ? (
                    attr.value.map((value, index) =>
                      attr.key ? (
                        <Link
                          as={NextLink}
                          key={index}
                          variant={"link"}
                          href={
                            attr.key === "author.en_AE"
                              ? `/a/${encodeURIComponent(value)}`
                              : `/s?products[refinementList][${
                                  attr.key
                                }][0]=${encodeURIComponent(value)}`
                          }
                          py={1.5}
                          color={"blue.600"}
                          textDecoration={"underline"}
                          textDecorationStyle={"dashed"}
                          textUnderlineOffset={"0.3em"}
                          _hover={{
                            textDecoration: "none",
                          }}
                        >
                          {value}
                        </Link>
                      ) : (
                        <Box key={index}>{value}</Box>
                      )
                    )
                  ) : attr.key ? (
                    <Link
                      as={NextLink}
                      key={index}
                      variant={"link"}
                      href={`/s?products[refinementList][${
                        attr.key
                      }][0]=${encodeURIComponent(attr.value)}`}
                      py={1.5}
                      color={"blue.600"}
                      textDecoration={"underline"}
                      textDecorationStyle={"dashed"}
                      textUnderlineOffset={"0.3em"}
                      _hover={{
                        textDecoration: "none",
                      }}
                    >
                      {attr.value}
                    </Link>
                  ) : (
                    <Box>{attr.value}</Box>
                  )}
                </Stack>
              </Flex>
            )
        )}
      </VStack>
    </Box>
  )
}

export default ProductDetails
